export default {
    API_BASE_URL: 'https://dev-cms.hdfcfund.com',
    VERSION: '/hdfc/api/v1',
    GA: {
        KEY: 'UA-107078077-1'
    },
    DISTRIBUTOR_URL:'https://dev-api.hdfcfund.com',
    DISTRIBUTOR:'/distributor',
    DISTRIBUTOR_VERSION:'/v1',
    INVESTOR_URL:'https://dev-api.hdfcfund.com',
    INVESTOR:'/investor',
    INVESTOR_VERSION:'/v1',
    INVESTOR_BASE_URL:'https://dev-investor.hdfcfund.com',
    WEB_BASE_URL:'https://dev.hdfcfund.com',
    SSR:true
}